(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atv-ny-hub"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const link = event.target.closest('[data-atv-route]');
  if (!link) return;
  const hub = link.closest('.atv-hub');
  const select = hub.querySelector('#atv-type');
  const option = select.querySelector('[data-route="' + link.dataset.atvRoute + '"]');
  if (option) select.value = option.value;
  const stage = hub.querySelector('#atv-stage');
  if (stage && link.dataset.atvStage) {
    const stageOption = stage.querySelector('[data-stage="' + link.dataset.atvStage + '"]');
    if (stageOption) stage.value = stageOption.value;
  }
});

  } catch(e) { console.error(e); }
})();
})();
